export default "__VITE_ASSET__CIKYCbwE__"